import { type Component } from "solid-js"
import InformationCircleSolid from "../../assets/heroicons/InformationCircleSolid"
import { useTracking } from "../../shared/providers/tracking.provider"

const NextSteps: Component = () => {
  const { trackSignupCtaClicked } = useTracking()

  return (
    <div class='w-full max-w-[655px] flex flex-col gap-6 text-sm p-4 bg-[#F1F5F9] rounded-lg text-gray-500 text-left'>
      <div class='flex flex-col gap-2 w-full'>
        <div class='flex flex-row gap-2 text-sm'>
          <span class='text-blue-500 mt-0.5'>
            <InformationCircleSolid />
          </span>
          <span class='mt-0.5 font-bold text-base'>
            Start Using Your ProfitTree Pro Plan Now!
          </span>
        </div>
        <ul class='list-disc pl-5'>
          <li>Sign up for ProfitTree using the <strong>same email address you used for your purchase.</strong></li>
          <li>Once signed up, your Pro Plan will be automatically activated.</li>
        </ul>
      </div>
      <a
        href='https://app.profittree.io'
        class='btn btn--black h-auto! w-fit! rounded-md!'
        onClick={() => { trackSignupCtaClicked() }}
      >
        Sign Up for ProfitTree
      </a>
    </div>
  )
}

export default NextSteps
